import { useEffect, useState } from "react";

interface FullscreenAccess {
  enabled: boolean;
  active: boolean;
  enter: () => Promise<void>;
  exit: () => Promise<void>;
}
export async function changeFullscreen(
  access: FullscreenAccess,
): Promise<string | null> {
  if (!access.enabled) return "Полный экран недоступен в этом браузере";
  try {
    await (access.active ? access.exit() : access.enter());
    return null;
  } catch {
    return "Полный экран недоступен.";
  }
}
function available(): boolean {
  return (
    document.fullscreenEnabled === true &&
    typeof document.documentElement.requestFullscreen === "function" &&
    typeof document.exitFullscreen === "function"
  );
}
export function FullscreenButton() {
  const [supported, setSupported] = useState(false);
  const [active, setActive] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const update = () => {
      setSupported(available());
      setActive(Boolean(document.fullscreenElement));
    };
    const failed = () => {
      update();
      setError(
        "Полный экран недоступен.",
      );
    };
    update();
    document.addEventListener("fullscreenchange", update);
    document.addEventListener("fullscreenerror", failed);
    return () => {
      document.removeEventListener("fullscreenchange", update);
      document.removeEventListener("fullscreenerror", failed);
    };
  }, []);
  return (
    <span className="fullscreen-control">
      <button
        className="fullscreen-button"
        data-testid="fullscreen-toggle"
        disabled={!supported || pending}
        aria-label={
          supported
            ? active
              ? "Выйти из полного экрана"
              : "Полный экран"
            : "Полный экран недоступен"
        }
        aria-pressed={active}
        title={
          supported
            ? active
              ? "Выйти из полного экрана"
              : "Полный экран"
            : "Этот браузер не предоставляет полноэкранный режим"
        }
        onClick={async () => {
          setPending(true);
          setError(
            await changeFullscreen({
              enabled: available(),
              active: Boolean(document.fullscreenElement),
              enter: () =>
                document.documentElement.requestFullscreen({
                  navigationUI: "hide",
                }),
              exit: () => document.exitFullscreen(),
            }),
          );
          setPending(false);
        }}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d={
              active
                ? "M4 9h5V4m6 0v5h5M4 15h5v5m6 0v-5h5"
                : "M9 4H4v5m11-5h5v5M4 15v5h5m6 0h5v-5"
            }
          />
        </svg>
      </button>
      {error && (
        <span className="fullscreen-status" role="status">
          {error}
        </span>
      )}
    </span>
  );
}
